import type { SVGProps } from "react";

/**
 * audio-fill, music-fill, musical-note-fill
 * @category Sound & Music
 */
export default function IconAudioFill(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 21 22.5329' fill='none' aria-hidden {...props}>
      <path
        d='M17.1648 2.38483C17.9133 2.16027 18.6667 2.72079 18.6667 3.5023V11.4161C17.9582 11.0609 17.15 10.8662 16.3333 10.8662C13.9642 10.8662 11.6667 12.5043 11.6667 14.9496C11.6667 17.3949 13.9642 19.0329 16.3333 19.0329C18.7025 19.0329 21 17.3949 21 14.9496V3.5023C21 1.15778 18.7399 -0.52379 16.4943 0.149903L9.49428 2.2499C8.01384 2.69404 7 4.05667 7 5.6023V14.9161C6.29152 14.5609 5.48334 14.3662 4.66667 14.3662C2.29754 14.3662 0 16.0043 0 18.4496C0 20.8949 2.29754 22.5329 4.66667 22.5329C7.03579 22.5329 9.33333 20.8949 9.33333 18.4496V5.6023C9.33333 5.08709 9.67128 4.63288 10.1648 4.48483L17.1648 2.38483Z'
        fill='currentColor'
      />
    </svg>
  );
}
